import {Component, Inject, Input, PLATFORM_ID} from '@angular/core';
import {DcpSupportFormService} from '@app/shared/support-form/dcp-support-form.service';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'dcp-generic-call-error',
  templateUrl: './generic-call-error.component.html'
})
export class GenericCallErrorComponent {
  @Input() isOpen: boolean = true;

  constructor(@Inject(PLATFORM_ID) public platformId: object, public dcpSupportFormService: DcpSupportFormService) {
  }

  refreshPage(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.reload();
    }
  }

  closeMessage(): void {
    this.isOpen = false;
  }
}
